import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d148bfe0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d148bfe0')) {
      api.createRecord('d148bfe0', component.options)
    } else {
      api.reload('d148bfe0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d148bfe0", function () {
      api.rerender('d148bfe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/majorSmallType/index.vue"
export default component.exports